module.exports = __webpack_public_path__ + "img/tree-05-a-leaves.fc42dc62.png";